import { Signal, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { toAsyncState, AsyncState } from '../async-state';

export const refreshable = <T>(sourceFn: () => Observable<T>) => {
  const trigger = signal(0);

  const state: Signal<AsyncState<T>> = toSignal(
    toObservable(trigger).pipe(
      // emit whenever trigger changes
      startWith(0), // fire once on creation
      switchMap(() => sourceFn().pipe(toAsyncState())),
    ),
    {
      initialValue: {
        inProgress: false,
        hasError: false,
        errorMessage: null,
        data: null,
      } as AsyncState<T>,
    },
  );

  return {
    state,
    refresh: () => trigger.update(v => v + 1),
  };
};
